(function () {
  'use strict';

  var FLAG = 'inapp_escaped';
  var ua = navigator.userAgent || '';
  var isAndroid = /Android/i.test(ua);
  var isIPhone = /iPhone/i.test(ua);
  var isInstagram = /Instagram/i.test(ua);
  var isFacebook = /FBAN|FBAV|FB_IAB|Messenger/i.test(ua);
  var isTikTok = /TikTok|BytedanceWebview|musical_ly/i.test(ua);
  var isInApp = isInstagram || isFacebook || isTikTok;

  if (!isInApp) return;

  try {
    if (new URLSearchParams(location.search).get(FLAG) === '1') return;
    if (sessionStorage.getItem(FLAG) === '1') return;
  } catch (e) {}

  function appleAGen() {
    try {
      var c = document.createElement('canvas');
      var gl = c.getContext('webgl') || c.getContext('experimental-webgl');
      if (!gl) return null;
      var dbg = gl.getExtension('WEBGL_debug_renderer_info');
      if (!dbg) return null;
      var renderer = String(gl.getParameter(dbg.UNMASKED_RENDERER_WEBGL) || '');
      var m = renderer.match(/Apple\s*A(\d+)/i);
      return m ? parseInt(m[1], 10) : null;
    } catch (e) {
      return null;
    }
  }

  function isClassicPreNotchIphone() {
    var w = Math.min(screen.width, screen.height);
    var h = Math.max(screen.width, screen.height);
    if (w === 375 && h === 667) return true; // 6/7/8
    if (w === 414 && h === 736) return true; // Plus
    if (w === 320 && h === 568) return true; // SE 1st
    return false;
  }

  function isIphoneOlderThan11() {
    if (!isIPhone) return false;
    var gen = appleAGen();
    if (gen != null) return gen < 13;
    return isClassicPreNotchIphone();
  }

  if (!(isAndroid || isIphoneOlderThan11())) return;

  function withFlag(url) {
    try {
      var u = new URL(url, location.origin);
      u.searchParams.set(FLAG, '1');
      return u.toString();
    } catch (e) {
      return url + (url.indexOf('?') === -1 ? '?' : '&') + FLAG + '=1';
    }
  }

  function markEscaped() {
    try { sessionStorage.setItem(FLAG, '1'); } catch (e) {}
  }

  function androidIntent(httpsUrl) {
    var stripped = httpsUrl.replace(/^https?:\/\//i, '');
    return (
      'intent://' + stripped +
      '#Intent;scheme=https;action=android.intent.action.VIEW;' +
      'category=android.intent.category.BROWSABLE;' +
      'S.browser_fallback_url=' + encodeURIComponent(httpsUrl) + ';end'
    );
  }

  function tryEscape() {
    var target = withFlag(location.href);
    markEscaped();
    if (isAndroid) {
      location.href = androidIntent(target);
      return;
    }
    if (isInstagram) {
      location.href = 'instagram://extbrowser/?url=' + encodeURIComponent(target);
      return;
    }
    if (isFacebook) {
      location.href = target.replace(/^https:\/\//i, 'x-safari-https://');
    }
  }

  function showBanner() {
    if (document.getElementById('inapp-escape-banner')) return;
    var target = withFlag(location.href);

    var bar = document.createElement('div');
    bar.id = 'inapp-escape-banner';
    bar.style.cssText =
      'position:fixed;z-index:2147483647;left:12px;right:12px;bottom:12px;' +
      'padding:14px 16px;border-radius:12px;background:#111;color:#fff;' +
      'font:600 14px/1.35 system-ui,sans-serif;box-shadow:0 8px 28px rgba(0,0,0,.35);' +
      'display:flex;gap:12px;align-items:center;';

    var text = document.createElement('p');
    text.style.cssText = 'margin:0;flex:1;';
    text.textContent = 'Daha hızlı alışveriş için tarayıcıda açın';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.textContent = 'Tarayıcıda aç';
    btn.style.cssText =
      'border:0;border-radius:999px;padding:10px 14px;background:#fff;color:#111;' +
      'font:700 13px system-ui,sans-serif;cursor:pointer;white-space:nowrap;';

    var close = document.createElement('button');
    close.type = 'button';
    close.textContent = '×';
    close.setAttribute('aria-label', 'Close');
    close.style.cssText =
      'border:0;background:transparent;color:#fff;font:700 22px/1 system-ui,sans-serif;cursor:pointer;';

    btn.addEventListener('click', function () {
      markEscaped();
      if (isAndroid) location.href = androidIntent(target);
      else if (isInstagram) location.href = 'instagram://extbrowser/?url=' + encodeURIComponent(target);
      else if (isFacebook) location.href = target.replace(/^https:\/\//i, 'x-safari-https://');
    });
    close.addEventListener('click', function () { bar.remove(); });

    bar.appendChild(text);
    bar.appendChild(btn);
    bar.appendChild(close);

    function mount() { document.body.appendChild(bar); }
    if (document.body) mount();
    else document.addEventListener('DOMContentLoaded', mount);
  }

  tryEscape();
  showBanner(); // iPhone often needs a tap — show immediately
})();